module.exports = __webpack_public_path__ + "static/21-799be021481f8c6d8ba059f5d4e3e86d.mp4";